import * as React from "react";
import moment from "moment-jalaali";
import {Col, Form, Input, Row, TimePicker, Select, InputNumber} from "antd";
import {createRequest, fetchItemRequest, updateRequest} from "@actions/subscription";
import {Subscription} from "@models/subscription";
import TextEditor, {TextEditorRef} from "@components/custom/TextEditor";
import {FormattedMessage} from "react-intl";
import subscriptionApi from "@api/subscription";
import withFormWrapper from "@hocs/withFormWrapper";
import {SelectionMode} from '@models';
import {Channel} from '@models/channel';
import DatePicker from "react-datepicker2";
import {toUTC, showDate} from "@utils";
import PackagesSelection from "@components/packages/Selection";
import ClientsSelection from "@components/clients/Selection";
import PackageApproachsSelection from "@components/packages/approach/Selection";
import {SubscriptionStatusOptions} from "@models/subscription";
import {PaymentGatewayOptions} from "../../models/paymentGateway";
import {REGEX_PATTERNS} from "../../constants/regex";
import {Package} from '../../models/package';
import {Client} from '../../models/client';
import {PaymentApproach} from "../../models/paymentApproach";
import {PurchaseStatusOptions} from "../../models/purchase";
import VideoSelection from "@components/video-contents/Selection";
import __i18n from "../../intl/__i18n";


const {Option} = Select

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  subscription?: Subscription;
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
  fetchItemRequest: typeof fetchItemRequest;
}

type SubscriptionFormAllProps = PropsFromState & PropsFromDispatch;

type SubscriptionFormStateShape = Subscription & {
  visible: boolean;
};


class SubscriptionForm extends React.Component<SubscriptionFormAllProps,
  SubscriptionFormStateShape> {
  constructor(props) {
    super(props);
    const {subscription} = props;
    this.state = {
      visible: false,
      ...this.getStateFromProps(subscription)
    };
  }
  
  private textEditorRef = React.createRef<TextEditorRef>();
  
  getStateFromProps = (subscription: Subscription | null) => {
    const obj = subscription || {};
    
    return {
      msisdn: obj.user_identifier || "",
      package: obj.package,
      start_time: obj.start_time && obj.start_date != "0001-01-01T00:00:00" ? moment(showDate(obj.start_time)) : null,
      end_time: obj.end_time && obj.start_date != "0001-01-01T00:00:00" ? moment(showDate(obj.end_time)) : null,
      status: obj.id ? obj.status : null,
      used_internal_balance_amount: obj.used_internal_balance_amount || 0,
      payment_gateway: obj ? obj.payment_gateway : null,
      id: obj.id,
    };
  };
  
  fetchItem = () => {
    subscriptionApi
      .getItem({
        params: {
          id: this.state.id
        }
      })
      .then(({data}) => {
        const obj = this.getStateFromProps(data);
        this.setState(obj);
      })
      .catch(error => console.log(error));
  };
  
  getValues = () => {
    let returnValues = null;
    
    this.props.form.setFieldsValue({
      "client_id": this.state.client && this.state.client.id,
      "package_purchase_template_id": this.state.package ? this.state.package.id : null,
      "package_payment_approach_id": this.state.packagePaymentApproach ? this.state.packagePaymentApproach.id : null,
    });
    
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = values
      }
    });
    
    return {
      payload: returnValues,// !this.state.id ? returnValues : this.getPatchPayload(returnValues),
      id: this.state.id,
      // patch: this.state.id ? true : false
    };
  };
  
  onChangeApproach = (item: PaymentApproach) => {
    this.setState({
      "packagePaymentApproach": item
    });
  };
  
  onChangePackage = (item: Package) => {
    this.setState({
      "package": item
    });
  };
  
  onChangeClient = (item: Client) => {
    this.setState({
      client: item
    });
  };
  
  onChangeVideo = (content) => {
    this.props.form.setFieldsValue({
      'product_reference_id': content.id
    })
  };
  
  render() {
    const {getFieldDecorator, getFieldValue} = this.props.form;
    return (
      <Form className={'subscription-form'}>
        <Row>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.client" defaultMessage={`Client`}/>}>
              {getFieldDecorator("client_id", {
                initialValue: this.state.client && this.state.client.id,
                rules: [{
                  required: true,
                  message: <FormattedMessage id="app.client_is_required" defaultMessage={`Client is required!`}/>
                }]
              })(
                <ClientsSelection
                  mode={SelectionMode.DEFAULT}
                  disabled={this.state.id ? true : false}
                  onChange={this.onChangeClient}
                  initialValue={this.state.client || null}
                />
              )}
            </Form.Item>
          </Col>
          
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.msisdn" defaultMessage={`Mobile Number`}/>}>
              {getFieldDecorator("msisdn", {
                initialValue: this.state.msisdn,
                rules: [{
                  required: true,
                  message: (<FormattedMessage id="app.mobile_is_required" defaultMessage={`Mobile is required`}/>)
                }, {
                  pattern: REGEX_PATTERNS.MOBILE,
                  message: <FormattedMessage id="app.value_is_not_valid" defaultMessage={`The value is not valid!`}/>
                }]
              })(<Input disabled={this.state.id ? true : false} placeholder={"989121111111"}/>)}
            </Form.Item>
          </Col>
  
          <Col span={8}>
            <Form.Item label={__i18n("Select Video")}>
              {getFieldDecorator("product_reference_id", {
                initialValue: this.state.product_reference ? this.state.product_reference.id : null,
                rules: [{
                  // whitespace: true,
                  required: true,
                  message: __i18n("{field} is required.", { field : __i18n("video")})
                }]
              })(<Input type={`hidden`}/>)}
              <VideoSelection mode={SelectionMode.DEFAULT}
                              initialValue={this.state.product_reference}
                              onChange={this.onChangeVideo}/>
            </Form.Item>
          </Col>
  
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.package" defaultMessage={`Package`}/>}>
              {getFieldDecorator("package_purchase_template_id", {
                rules: [{
                  required: true,
                  message: <FormattedMessage id="app.package_is_required" defaultMessage={`Package is required!`}/>
                }]
              })}
              <PackagesSelection
                mode={SelectionMode.DEFAULT}
                disabled={this.state.id ? true : false}
                onChange={this.onChangePackage}
                initialValue={this.state.package || null}
              />
            </Form.Item>
          </Col>
  
  
          <Col span={8}>
            <Form.Item label={ __i18n("Package Payment Approach")}>
              {getFieldDecorator("package_payment_approach_id", {
                rules: [{
                  required: true,
                  message: __i18n("{field} is required.", {
                    field: __i18n("Package Payment Approach")
                  })
                }]
              })(
                <PackageApproachsSelection
                  mode={SelectionMode.DEFAULT}
                  packageId={this.state.package ? this.state.package.id : null}
                  disabled={this.state.package ? false : true}
                  onChange={this.onChangeApproach}
                  initialValue={null}/>
              )}
            </Form.Item>
          </Col>
          
          <Col span={8}>
            <Form.Item
              label={<FormattedMessage id="app.status" defaultMessage={`Status`}/>}>
              {getFieldDecorator("status", {
                initialValue: this.state.status,
                rules: [{
                  required: true,
                  message: <FormattedMessage id="app.status_is_required" defaultMessage={`Status is required!`}/>
                }]
              })(
                <Select>
                  {PurchaseStatusOptions.map((opt, index) => (
                    <Option key={index} value={opt.value}>
                      {opt.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
  
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.used_internal_balance_amount"
                                                defaultMessage={`Used Internal Balance Amount`}/>}>
              {getFieldDecorator("used_internal_balance_amount", {
                initialValue: this.state.used_internal_balance_amount
              })(<InputNumber disabled={this.state.id ? true : false} min={0}/>)}
            </Form.Item>
          </Col>
  
          <Col span={8}>
            <Form.Item
              label={__i18n("Payment Gateway")}>
              {getFieldDecorator("payment_gateway", {
                initialValue: this.state.payment_gateway,
                rules: [{
                  required: true,
                  message: __i18n("{field} is required.", {
                    field: __i18n("Payment Gateway")
                  })
                }]
              })(
                <Select disabled={this.state.id ? true : false}>
                  {PaymentGatewayOptions.map((opt, index) => (
                    <Option key={index} value={opt.value}>
                      {opt.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
  
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.client_reference_id" defaultMessage={`Client Reference`}/>}>
              {getFieldDecorator("client_reference_id", {
                initialValue: this.state.client_reference_id,
              })(<Input/>)}
            </Form.Item>
          </Col>
  
        </Row>
      </Form>
    );
  }
}

export default withFormWrapper(
  Form.create({name: "subscription-form"})(SubscriptionForm)
);
